/* Similar-products carousel for product pages. No dependencies, no apps.
   Ranking (see sections/related-products.liquid):
     tier 0  same chain style, same product type (Chain/Bracelet), all finishes
     tier 1  same chain style, other product type
     tier 2  other styles, same product type (styles interleaved so one style can't flood the row)
     tier 3  anything else (only to reach the minimum)
   Inside a tier: nearest width first, then same finish, then title. The current product is always excluded. */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
  var cache = {};

  function num(v) { var n = parseFloat(v); return isNaN(n) ? null : n; }

  function fetchFeed(url) {
    if (!cache[url]) {
      cache[url] = fetch(url, { credentials: 'same-origin', headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var feed = doc.querySelector('[data-related-feed]');
          if (!feed) return { active: 0, pages: 0, items: [] };
          return {
            active: parseInt(feed.getAttribute('data-active'), 10) || 0,
            pages: parseInt(feed.getAttribute('data-pages'), 10) || 1,
            items: Array.prototype.map.call(feed.querySelectorAll('[data-related-item]'), function (el) {
              return {
                el: el,
                handle: el.getAttribute('data-handle'),
                style: el.getAttribute('data-style') || '',
                type: el.getAttribute('data-type') || '',
                width: num(el.getAttribute('data-width')),
                finish: el.getAttribute('data-finish') || '',
                title: el.getAttribute('data-title') || ''
              };
            })
          };
        });
    }
    return cache[url];
  }

  function feedUrl(base, handle, params) {
    var q = ['section_id=related-products-feed'];
    Object.keys(params || {}).forEach(function (k) { q.push(encodeURIComponent(k) + '=' + encodeURIComponent(params[k])); });
    return base.replace(/\/$/, '') + '/' + handle + '?' + q.join('&');
  }

  /* All products of a collection (used only if a storefront filter isn't recognised). */
  function fullScan(base, handle) {
    return fetchFeed(feedUrl(base, handle, { page: 1 })).then(function (first) {
      var rest = [];
      for (var p = 2; p <= Math.min(first.pages, 1); p++) rest.push(fetchFeed(feedUrl(base, handle, { page: p })));
      return Promise.all(rest).then(function (more) {
        return more.reduce(function (acc, f) { return acc.concat(f.items); }, first.items.slice());
      });
    });
  }

  function rank(cur, items, limit, min) {
    var seen = {}; seen[cur.handle] = true;
    var pool = [];
    items.forEach(function (it) {
      if (!it.handle || seen[it.handle]) return;
      seen[it.handle] = true;
      var sameStyle = cur.style && it.style === cur.style;
      var sameType = it.type === cur.type;
      it.tier = sameStyle ? (sameType ? 0 : 1) : (sameType ? 2 : 3);
      it.dist = (cur.width != null && it.width != null) ? Math.abs(it.width - cur.width) : 99;
      pool.push(it);
    });
    function cmp(a, b) {
      return (a.dist - b.dist) || ((a.finish === cur.finish ? 0 : 1) - (b.finish === cur.finish ? 0 : 1)) || a.title.localeCompare(b.title);
    }
    var t0 = pool.filter(function (i) { return i.tier === 0; }).sort(cmp);
    var t1 = pool.filter(function (i) { return i.tier === 1; }).sort(cmp);
    var t3 = pool.filter(function (i) { return i.tier === 3; }).sort(cmp);
    // Tier 2: interleave styles, nearest-width style first.
    var groups = {};
    pool.filter(function (i) { return i.tier === 2; }).sort(cmp).forEach(function (i) { (groups[i.style] = groups[i.style] || []).push(i); });
    var order = Object.keys(groups).sort(function (a, b) { return cmp(groups[a][0], groups[b][0]); });
    var t2 = [];
    for (var round = 0, added = true; added; round++) {
      added = false;
      order.forEach(function (s) { if (groups[s][round]) { t2.push(groups[s][round]); added = true; } });
    }
    var out = t0.concat(t1, t2);
    if (out.length < min) out = out.concat(t3.slice(0, min - out.length));
    return out.slice(0, limit);
  }

  function Carousel(root) {
    this.root = root;
    this.track = root.querySelector('[data-related-track]');
    this.prev = root.querySelector('[data-related-prev]');
    this.next = root.querySelector('[data-related-next]');
    this.toggle = root.querySelector('[data-related-toggle]');
    this.interval = parseInt(root.getAttribute('data-interval'), 10) || 5000;
    this.enabled = root.getAttribute('data-autoplay') !== 'false';
    this.reasons = {};
    this.optIn = false;
    this.timer = null;
    this.bind();
  }
  Carousel.prototype.step = function () {
    var slide = this.track.querySelector('.related__slide');
    if (!slide) return 0;
    var gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
    return slide.getBoundingClientRect().width + gap;
  };
  Carousel.prototype.go = function (dir) {
    var t = this.track, max = t.scrollWidth - t.clientWidth - 4;
    var behavior = reduceMotion.matches ? 'auto' : 'smooth';
    if (dir > 0 && t.scrollLeft >= max) t.scrollTo({ left: 0, behavior: behavior });
    else if (dir < 0 && t.scrollLeft <= 4) t.scrollTo({ left: t.scrollWidth, behavior: behavior });
    else t.scrollBy({ left: dir * this.step(), behavior: behavior });
  };
  Carousel.prototype.canPlay = function () {
    return this.enabled && (!reduceMotion.matches || this.optIn) && Object.keys(this.reasons).length === 0 &&
      this.track.scrollWidth > this.track.clientWidth + 4;
  };
  Carousel.prototype.sync = function () {
    var self = this;
    clearInterval(this.timer); this.timer = null;
    if (this.canPlay()) this.timer = setInterval(function () { self.go(1); }, this.interval);
    var overflow = this.track.scrollWidth > this.track.clientWidth + 4;
    this.prev.hidden = this.next.hidden = !overflow;
    if (this.toggle) {
      this.toggle.hidden = !overflow || !this.enabled;
      var paused = !!this.reasons.user || (reduceMotion.matches && !this.optIn);
      this.toggle.setAttribute('aria-pressed', paused ? 'true' : 'false');
      this.toggle.setAttribute('aria-label', paused ? 'Start automatic scrolling' : 'Pause automatic scrolling');
    }
  };
  Carousel.prototype.pause = function (why) { this.reasons[why] = true; this.sync(); };
  Carousel.prototype.resume = function (why) { delete this.reasons[why]; this.sync(); };
  Carousel.prototype.bind = function () {
    var self = this, root = this.root, touchTimer;
    this.prev.addEventListener('click', function () { self.go(-1); self.sync(); });
    this.next.addEventListener('click', function () { self.go(1); self.sync(); });
    if (this.toggle) this.toggle.addEventListener('click', function () {
      var paused = !!self.reasons.user || (reduceMotion.matches && !self.optIn);
      if (paused) { delete self.reasons.user; if (reduceMotion.matches) self.optIn = true; } // explicit opt-in only
      else self.reasons.user = true;
      self.sync();
    });
    root.addEventListener('mouseenter', function () { self.pause('hover'); });
    root.addEventListener('mouseleave', function () { self.resume('hover'); });
    root.addEventListener('focusin', function () { self.pause('focus'); });
    root.addEventListener('focusout', function (e) { if (!root.contains(e.relatedTarget)) self.resume('focus'); });
    root.addEventListener('touchstart', function () { clearTimeout(touchTimer); self.pause('touch'); }, { passive: true });
    root.addEventListener('touchend', function () { clearTimeout(touchTimer); touchTimer = setTimeout(function () { self.resume('touch'); }, 8000); }, { passive: true });
    this.track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); self.go(1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); self.go(-1); }
    });
    document.addEventListener('visibilitychange', function () { document.hidden ? self.pause('hidden') : self.resume('hidden'); });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { en.isIntersecting ? self.resume('offscreen') : self.pause('offscreen'); });
      }, { threshold: 0.25 }).observe(root);
    }
    if (reduceMotion.addEventListener) reduceMotion.addEventListener('change', function () { self.sync(); });
    window.addEventListener('resize', function () { self.sync(); });
    this.sync();
  };

  function render(root, carousel, list) {
    if (!list.length) return;
    var frag = document.createDocumentFragment();
    list.forEach(function (it) {
      var li = document.createElement('li');
      li.className = 'related__slide';
      li.setAttribute('data-related-item', '');
      li.setAttribute('data-handle', it.handle);
      Array.prototype.forEach.call(it.el.childNodes, function (n) { li.appendChild(document.importNode(n, true)); });
      frag.appendChild(li);
    });
    carousel.track.innerHTML = '';
    carousel.track.appendChild(frag);
    carousel.track.scrollLeft = 0;
    root.setAttribute('data-related-ready', '');
    carousel.sync();
  }

  function init(root) {
    if (root.__related) return;
    var carousel = root.__related = new Carousel(root);
    var d = root.dataset;
    var cur = { handle: d.handle, style: d.style, type: d.type, width: num(d.width), finish: d.finish };
    var limit = parseInt(d.limit, 10) || 12, min = parseInt(d.min, 10) || 8;
    var base = d.collectionsUrl || '/collections';
    var all = d.allHandle || 'italian-silver';

    // 1) same chain style, every finish and type (storefront filter on the chain_style metafield)
    var sameStyle = cur.style
      ? fetchFeed(feedUrl(base, all, { 'filter.p.m.custom.chain_style': cur.style })).then(function (f) {
          return f.active > 0 ? f.items : fullScan(base, all); // filter not recognised -> scan everything
        })
      : Promise.resolve([]);

    sameStyle.then(function (styleItems) {
      var pre = rank(cur, styleItems, limit, 0);
      if (pre.length >= limit) return styleItems;
      // 2) fill: other styles of the same product type
      var fill = cur.type === 'Bracelet'
        ? fetchFeed(feedUrl(base, d.braceletsHandle || 'silver-bracelets', {})).then(function (f) { return f.items; })
        : fetchFeed(feedUrl(base, all, { 'filter.p.product_type': cur.type })).then(function (f) {
            return f.active > 0 ? f.items : fullScan(base, all);
          });
      return fill.then(function (more) { return styleItems.concat(more); });
    }).then(function (items) {
      render(root, carousel, rank(cur, items, limit, min));
    }).catch(function () { /* keep the server-rendered fallback */ });
  }

  function lazyInit(root) {
    if (root.__relatedWatch || root.__related) return;
    if (!('IntersectionObserver' in window)) { init(root); return; }
    root.__relatedWatch = true;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { io.disconnect(); init(root); } });
    }, { rootMargin: '400px 0px' });
    io.observe(root);
  }
  function boot() { document.querySelectorAll('[data-related]').forEach(lazyInit); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
